import { useEffect, useMemo, useRef, useState } from 'react';
import { get, isEmpty, keyBy } from 'lodash';
import { useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { STATIC_FILTERS_MAP } from '../../../config';

export const useFilterOperatorState = ({ initialFilter, type, availableFiltersMap }) => {
    const { formatMessage } = useIntl();
    const { operator: initialOperator } = initialFilter || { value: get(availableFiltersMap, `${type}.operators[0]`) };
    const [operator, setOperator] = useState(initialOperator?.value);
    const operatorRef = useRef();
    const changeOperator = newOperator => {
        if (isEmpty(newOperator)) {
            setOperator();
            return;
        }
        setOperator(newOperator);
    };
    const operatorOptions = useMemo(() => {
        if (!type) {
            return [];
        }

        const options = (
            get(availableFiltersMap, `${type}.operators`) || get(STATIC_FILTERS_MAP, `${type}.operators`, [])
        ).map(key => ({
            value: key,
            label: formatMessage({ id: `app.campaigns.reports.filters.range_based.${key}`, defaultMessage: key }),
        }));

        return options;
    }, [type, availableFiltersMap, formatMessage]);
    const operatorOptionsMap = useMemo(() => keyBy(operatorOptions, 'value'), [operatorOptions]);
    const operatorLabel = operatorOptionsMap[operator]?.label;

    useEffect(() => {
        if (type && isEmpty(operator)) {
            if (operatorRef.current) {
                operatorRef.current.select.focus();
            }
        }
    }, [type, operatorRef, operator]);

    return { operator, operatorLabel, setOperator: changeOperator, operatorOptions, operatorRef };
};
